// eslint-disable-next-line @typescript-eslint/prefer-optional-chain
export default !!(typeof navigator !== 'undefined' &&
navigator.vendor &&
navigator.vendor.includes('Apple') &&
navigator.userAgent &&
!navigator.userAgent.includes('CriOS') &&
!navigator.userAgent.includes('FxiOS'))
